import type { SVGProps } from 'react';
import React from 'react';

export const LogoIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="167"
      height="64"
      viewBox="0 0 167 64"
      fill="none"
      {...props}
    >
      <mask
        id="mask0_24_6"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="167"
        height="64"
      >
        <path
          d="M166.402 0H0V63.831H166.402V0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_24_6)">
        <path
          d="M35.281 1.33496L25.338 28.719C23.572 33.582 19.506 33.582 17.738 28.719L7.8 1.33496H0L12.191 33.408C13.884 38.721 17.656 40.672 21.391 40.672C25.291 40.672 28.556 38.896 31.043 33.148L43.206 1.33496H35.281Z"
          fill="#48EEDF"
        />
        <path
          /* eslint-disable-next-line max-len */
          d="M75.932 5.608C73.0257 2.85627 69.3767 1.01657 65.4361 0.316335C61.4955 -0.383903 57.436 0.0860187 53.7596 1.66801C50.0832 3.25 46.951 5.87469 44.7502 9.21762C42.5494 12.5606 41.3765 16.4752 41.3765 20.4775C41.3765 24.4798 42.5494 28.3944 44.7502 31.7374C46.951 35.0803 50.0832 37.705 53.7596 39.287C57.436 40.869 61.4955 41.3389 65.4361 40.6387C69.3767 39.9384 73.0257 38.0987 75.932 35.347V39.833H82.469V1.433H75.932V5.608ZM61.875 34.308C59.1389 34.308 56.4642 33.4967 54.1893 31.9766C51.9143 30.4565 50.1411 28.2959 49.0941 25.768C48.047 23.2402 47.773 20.4587 48.3068 17.7751C48.8406 15.0916 50.1582 12.6266 52.0929 10.6919C54.0276 8.75716 56.4926 7.4396 59.1761 6.90582C61.8597 6.37203 64.6412 6.64599 67.1691 7.69305C69.6969 8.74011 71.8575 10.5133 73.3776 12.7882C74.8977 15.0632 75.709 17.7379 75.709 20.474C75.7048 24.1417 74.2459 27.658 71.6525 30.2514C69.059 32.8449 65.5427 34.3038 61.875 34.308Z"
          fill="#48EEDF"
        />
        <path
          /* eslint-disable-next-line max-len */
          d="M121.278 5.41023V21.9772C120.924 25.4282 119.285 28.62 116.688 30.9198C114.091 33.2196 110.724 34.4594 107.256 34.3935C103.787 34.3276 100.47 32.9607 97.9619 30.5638C95.4539 28.167 93.9381 24.9152 93.7151 21.4532V1.36523H87.0421V20.5652C87.0406 24.5311 88.1913 28.412 90.3543 31.7361C92.5172 35.0603 95.5992 37.6845 99.2257 39.2898C102.852 40.8951 106.867 41.4123 110.782 40.7786C114.697 40.1449 118.343 38.3876 121.278 35.7202V44.1882H97.4551C94.5491 44.1882 86.9341 45.7452 86.9341 54.0742C86.9341 62.4032 94.5491 63.8322 97.4551 63.8322H127.564V57.3532H98.8811C96.9271 57.3532 93.8351 57.1822 93.8351 54.0102C93.8351 50.8382 96.9271 50.6672 98.8811 50.6672H105.001V50.6722H123.627C124.212 50.682 124.792 50.5756 125.335 50.359C125.878 50.1424 126.373 49.82 126.79 49.4106C127.207 49.0012 127.539 48.5129 127.766 47.9741C127.993 47.4354 128.111 46.8568 128.112 46.2722V1.52023H121.276L121.278 5.41023Z"
          fill="#48EEDF"
        />
        <path
          /* eslint-disable-next-line max-len */
          d="M159.992 1.625V23.867C160.014 25.7183 159.526 27.54 158.581 29.132C157.669 30.6717 156.379 31.9534 154.834 32.856C154.81 32.8658 154.787 32.8768 154.764 32.889C153.17 33.8017 151.366 34.2819 149.529 34.2819C147.692 34.2819 145.888 33.8017 144.294 32.889C144.271 32.8768 144.248 32.8658 144.224 32.856C142.679 31.9534 141.389 30.6717 140.477 29.132C139.532 27.5401 139.043 25.7183 139.066 23.867V1.625H132.654V25.279C132.62 28.0269 133.339 30.7316 134.733 33.1C136.092 35.4126 138.024 37.3369 140.341 38.688C142.694 40.074 145.703 40.768 150.16 40.768C153.14 40.7969 156.08 40.082 158.714 38.688C161.031 37.3369 162.963 35.4126 164.322 33.1C165.716 30.7316 166.435 28.0269 166.401 25.279V1.625H159.992Z"
          fill="#48EEDF"
        />
      </g>
    </svg>
  );
};